
export class ReceiptPaperDetail {
    id: string;
    receipt_paper_id: string;
    name: string | null;
    unit_price: number;
    /** ODR-1704: 領収書1枚あたりの個数（発行枚数ぶん各領収書に載る） */
    quantity: number;
    tax_rate: number;
    price: number;
    is_naizei: boolean;
    tax: number;
    /**
     * ODR-1704: この領収書に含めるか（画面用。送信時は取り除く）。
     * 商品・金券と同じ一覧に並べてチェックで選択できるようにするためのフラグ。
     */
    is_checked?: boolean;
}

/** ODR-1704: 追加明細の1枚あたり個数の上限 */
export const RECEIPT_PAPER_DETAIL_MAX_QUANTITY = 99;

export function createEmptyReceiptPaperDetail(): ReceiptPaperDetail {
  return {
    id: null,
    name: '',
    receipt_paper_id: '',
    unit_price: 0,
    // ODR-1704: 1枚あたり個数。追加直後から1枚分として数えられるよう既定1。
    quantity: 1,
    tax_rate: 10,
    price: 0,
    is_naizei: false,
    tax: 0,
    is_checked: true,
  };
}
